import { render, staticRenderFns } from "./cataractnnvmpSP.vue?vue&type=template&id=0389d3e2&scoped=true"
import script from "./cataractnnvmpSP.vue?vue&type=script&lang=js"
export * from "./cataractnnvmpSP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0389d3e2",
  null
  
)

export default component.exports